import { colors } from "../../../../../../../../../colorVars";
import { Body3 } from "../../../../../../../../../components/atomic/text/Text";

export function multiSymbolOptionPlanBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
      Cannot execute multi-symbol option plan.
      </Body3>
    </td>
  );
}
